module.exports = __webpack_public_path__ + "static/media/apple.2747cf85.svg";